var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "147px",
    height: "104px",
    viewBox: "0 0 147 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "686A82F2-6835-4D94-8682-8421AA993EF4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 147,
    height: 104,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-729.000000, -1014.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Choice",
    transform: "translate(729.000000, 1014.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FAFAFC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 130,
    height: 34.587156
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 130,
    height: 34.587156
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 0,
    y: 9,
    width: 120,
    height: 16.0893855,
    rx: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "Title",
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontSize: 5,
    fontWeight: 500,
    fill: "#909090"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "Title")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-5",
    transform: "translate(4.000000, 14.413408)",
    fill: "#9A9A9A",
    fontFamily: "OpenSans, Open Sans",
    fontSize: 5,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Please-select-one"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5
  }, "Please select  one"))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoice);
export default __webpack_public_path__ + "static/media/Choice.e6217008902e0c238964518783d78768.svg";
export { ForwardRef as ReactComponent };